import {Grid} from "@mui/material";
import React, {useEffect} from "react";
import {useTranslation} from "react-i18next";
import {FormAutocomplete} from "../../../common/form-fields";
import {useRecoilState} from "recoil";
import "dayjs/locale/it";
import {SelectElementModelFE} from "../../../api/types/generic";
import {useFormContext} from "react-hook-form";
import CustomBanner from "../../../common/components/CustomBanner";
import {ExceptionListEntityResponse} from "../../../api/types/exceptionList";
import {exceptionListsAtom} from "../../../state/exceptionListsRecoil";
import {FormExceptionListAncillaryExceptionModel} from "../../../api/types/exceptionListAncillaryExceptionModel";
import {useExceptionListRepository} from "../../../api/repositories/ExceptionListRepository";
import {ancillaryExceptionSelectAtom} from "../../../state/ancillaryExceptionRecoil";
import {useAncillaryExceptionRepository} from "../../../api/repositories/AncillaryExceptionRepository";
import {AncillaryExceptionEntityResponse, AncillaryExceptionSelectFE} from "../../../api/types/ancillaryException";
import {selectedExceptionListAncillaryExceptionAtom} from "../../../state/exceptionListAncillaryExceptionsRecoil";
import {fromAncillaryExceptionBeToFe} from "../../../utils";

const FormExceptionListAncillaryException = ({
                                                 exceptionListInUse,
                                                 setExceptionListInUse,
                                                 readOnly,
                                             }: { exceptionListInUse: boolean; setExceptionListInUse: Function; readOnly: boolean; }) => {
    // Use Translation
    const {t} = useTranslation(["translation", "pricing"]);

    // Use Form Context
    const {register, setValue, watch} = useFormContext<FormExceptionListAncillaryExceptionModel>();
    const watchAllForm = watch();

    // Use Recoil
    const [ancillaryExceptions, setAncillaryExceptions] = useRecoilState(ancillaryExceptionSelectAtom);
    const [exceptionLists] = useRecoilState(exceptionListsAtom);
    const [selectedExceptionListAncillaryException] = useRecoilState(selectedExceptionListAncillaryExceptionAtom);

    // Use Repository Hooks
    const {getAncillaryExceptionsByExceptionListAndCommercialCategory} = useAncillaryExceptionRepository();
    const {isExceptionListInUse, getExceptionList} = useExceptionListRepository();

    useEffect(() => {
        if (selectedExceptionListAncillaryException) {
            const exceptionList = selectedExceptionListAncillaryException?.exceptionList;
            handleChangeExceptionList({
                code: exceptionList.id,
                label: exceptionList.name
            });
        }
    }, [selectedExceptionListAncillaryException]);

    const handleChangeExceptionList = async (value: SelectElementModelFE) => {
        setValue("exceptionList", value);
        setValue("ancillaryExceptions", []);
        const exceptionList: ExceptionListEntityResponse = await getExceptionList(
            value.code as number
        );

        const exceptionListInUse = await isExceptionListInUse(value.code as number);
        setExceptionListInUse(exceptionListInUse);

        const ancillaryExceptions: AncillaryExceptionEntityResponse[] = await getAncillaryExceptionsByExceptionListAndCommercialCategory({
            exceptionListId: value.code as number,
            commercialCategoryId: exceptionList?.commercialCategory.id as string
        });
        const ancillaryExceptionsFe: AncillaryExceptionSelectFE[] = fromAncillaryExceptionBeToFe(ancillaryExceptions).sort((a: AncillaryExceptionSelectFE, b: AncillaryExceptionSelectFE) => a.label.localeCompare(b.label));
        setAncillaryExceptions([{
            code: 0,
            label: t("pricing:actions.selectAll")
        }, ...ancillaryExceptionsFe]);

    };

    const handleChangeAncillaryExceptions = (
        input: AncillaryExceptionSelectFE[]
    ) => {
        const value: AncillaryExceptionSelectFE[] =
            // è stato cliccato "selectAll"
            input.find((el: AncillaryExceptionSelectFE) => el.code === 0) &&
            // tra i vecchi valori non c'è "selectAll
            !watchAllForm.ancillaryExceptions?.find(
                (el: AncillaryExceptionSelectFE) => el.code === 0
            )
                ? // applica il "selectAll
                ancillaryExceptions.filter(
                    (el: AncillaryExceptionSelectFE) => el.code !== 0
                )
                : // setta solo locations selezionati
                input.filter((el) => el.code !== 0);
        setValue("ancillaryExceptions", value);
    };

    return (
        <Grid container spacing={2} alignItems="start">
            {exceptionListInUse &&
                <Grid xs={12}>
                    <CustomBanner message={t("pricing:exceptionList.banner")} severity={"warning"}/>
                </Grid>
            }
            <Grid item xs={12} md={3}>
                <FormAutocomplete
                    {...register("exceptionList")}
                    label={`${t("pricing:exceptionList.table.headers.exceptionList")}*`}
                    options={exceptionLists}
                    multiple={false}
                    isOptionEqualToValue={(option, value) => option === value}
                    handleChange={handleChangeExceptionList}
                />
            </Grid>
            <Grid item xs={12} md={3}>
                <FormAutocomplete
                    {...register("ancillaryExceptions")}
                    label={`${t("pricing:exceptionList.table.headers.ancillaryExceptions")}*`}
                    options={ancillaryExceptions}
                    multiple={true}
                    isOptionEqualToValue={(option, value) => option.code === value.code}
                    handleChange={handleChangeAncillaryExceptions}
                />
            </Grid>
            {/*<DealerAndTenant*/}
            {/*    readOnly={readOnly}*/}
            {/*    md={3}*/}
            {/*    legalEntityName={"legalEntity"}*/}
            {/*    dealerName={"dealer"}*/}
            {/*    dealerIsVisible={true}*/}
            {/*/>*/}
        </Grid>
    );
};

export default FormExceptionListAncillaryException;
